// ======================================================================
// File Name       : participant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { commonCallApi } from '../../utils/ApiUtils';
import { SELECT_TARGET_DATA } from '../../constants';

export function getRelationStatusList(data) {
  return commonCallApi({
    path: 'learningOperation/GetStatusLive',
    data,
  });
}

